<script setup lang="ts">
import { onBeforeUnmount, useId } from "vue";
defineOptions({ name: "BaseTextArea" });
const model = defineModel<string | undefined>();
const props = defineProps<{
  placeholder: string;
  label?: string;
  rows?: number;
}>();
const inputId = useId();

onBeforeUnmount(() => {
  // no-op: placeholder for future cleanup hooks
});
</script>
<template>
  <textarea
    :id="inputId"
    class="textbox"
    :placeholder="props.placeholder"
    :rows="props.rows ?? 4"
    :aria-label="props.label || props.placeholder"
    :value="model"
    @input="model = ($event.target as HTMLTextAreaElement).value"
  />
</template>
